import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { EllipsisItem, FirstItem, LastItem, NextItem, PaginationItem, PrevItem } from './PaginationItem';
// eslint-disable-next-line react/display-name
export const Pagination = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, bsSize, align, ...rest } = props;
    const bsClass = classnames('pagination', {
        [`pagination-${bsSize}`]: !!bsSize
    }, {
        'justify-content-center': align === 'center'
    }, {
        'justify-content-end': align === 'right'
    }, className);
    return /*#__PURE__*/ _jsx("ul", {
        ...rest,
        ref: ref,
        className: bsClass
    });
});
Pagination.displayName = 'Pagination';
Pagination.Item = PaginationItem;
Pagination.First = FirstItem;
Pagination.Last = LastItem;
Pagination.Prev = PrevItem;
Pagination.Next = NextItem;
Pagination.Ellipsis = EllipsisItem;
